import React, { useContext, useMemo } from "react";
import { classNameHelper } from "../../../../other/utils/utils.jsx";
import { SwivuContextMenu } from "../../SwivuContextMenu.jsx";
import { GRANTS } from "../../../../other/constants/PrivilegeTypes.jsx";
import BryntumContext from "../../../context/bryntumContext.jsx";
import { REACT_EDITOR_CONTEXT_MENU_KEYS } from "../../../../other/constants/OtherKeys.jsx";
import { openSwivuAssistPopup } from "../../../../other/utils/utils.jsx";

const mergeMenuConfigs = (newConfig = {}, defaultConfig) => {
  return Object.entries(defaultConfig).reduce((acc, [key, value]) => {
    acc[key] = newConfig[key] ?? value;
    return acc;
  }, {});

}

export function BaseModalHeader({ title, description, onClose, className, titleCls, record, iconCls, contextMenuConfig = {}, version, swivuAssistanceConfig, hideMenu, ...props }) {
  const { user, editorHandler } = useContext(BryntumContext);
  const menuOptionConfig = useMemo(() => {
    const config = { ...contextMenuConfig };

    const canOperate = user && user.can(GRANTS.grant_three);
    config[REACT_EDITOR_CONTEXT_MENU_KEYS.UNARCHIVE] = mergeMenuConfigs(contextMenuConfig[REACT_EDITOR_CONTEXT_MENU_KEYS.UNARCHIVE], {
      label: "Unarchive",
      icon: "fas fa-folder-open",
      disabled: !canOperate,
      hidden: record.isPhantom || !record.archived,
      onClick: () => {
        if (canOperate) {
          record.archived = false;
          onClose();
        }
      }
    })

    config[REACT_EDITOR_CONTEXT_MENU_KEYS.DELETE] = mergeMenuConfigs(contextMenuConfig[REACT_EDITOR_CONTEXT_MENU_KEYS.DELETE], {
      label: "Delete",
      icon: "fas fa-trash",
      disabled: !canOperate,
      hidden: record.isPhantom || !record.archived,
      onClick: () => {
        if (canOperate) {
          record.firstStore.remove(record);
          onClose();
        }
      },
    })

    config[REACT_EDITOR_CONTEXT_MENU_KEYS.ARCHIVE] = mergeMenuConfigs(contextMenuConfig[REACT_EDITOR_CONTEXT_MENU_KEYS.ARCHIVE], {
      label: "Archive",
      icon: "fas fa-folder-open",
      disabled: !canOperate,
      hidden: record.isPhantom || record.archived,
      onClick: () => {
        if (canOperate) {
          record.archived = true;
          onClose();
        }
      },
    })

    if (swivuAssistanceConfig) {
      config[REACT_EDITOR_CONTEXT_MENU_KEYS.SWIVU_ASSIST] = mergeMenuConfigs(contextMenuConfig[REACT_EDITOR_CONTEXT_MENU_KEYS.SWIVU_ASSIST], {
        label: "Swivu Assist",
        icon: "fas fa-question",
        onClick: () => {
          openSwivuAssistPopup({ editorHandler, swivuAssistanceConfig });
        },
      })
    }

    return config;
  }, [record, version, swivuAssistanceConfig, contextMenuConfig, editorHandler]);

  return (
    <div
      className={classNameHelper(
        "drag-handle flex items-center justify-between p-swivu-base border-b border-border border-solid",
        className
      )}
      {...props}
    >
      <div className="flex items-center gap-3">
        {iconCls && <i className={classNameHelper("text-swivu-icon text-blue-600 dark:text-blue-400", iconCls)} />}
        <div className="flex flex-col gap-1 w-full">
          {title && <h2 className={classNameHelper("text-swivu-lg font-bold text-foreground m-0 truncate max-w-[40rem]", titleCls)}> {title}</h2>}
          {description && <p className="text-muted-foreground mt-2 md:mt-0 mb-0 text-swivu-sm">{description}</p>}
        </div>
      </div>

      <div className="flex items-center gap-1">
        {menuOptionConfig && !hideMenu && <SwivuContextMenu options={menuOptionConfig} buttonClassName="size-swivu-icon hover:bg-secondary rounded-swivu-base transition-colors bg-transparent border-0 font-swivu-modern text-base cursor-pointer flex items-center justify-center text-swivu-icon" className="left-[unset]" />}
        <button
          onClick={onClose}
          className="size-swivu-icon hover:bg-secondary rounded-swivu-base transition-colors bg-transparent border-0 font-swivu-modern text-base cursor-pointer flex items-center justify-center text-swivu-icon"
        >
          <i className="text-muted-foreground fas fa-times"></i>
        </button>
      </div>
    </div>
  );
}
